import React, {useState} from 'react';
import { useRouteNode } from 'react-router5';
import Tab from "../../components/tab/tab";
import Briefing from "../singleView/briefing";
import Themes from "../singleView/themes";
import Reseaux from "../singleView/reseaux";
import Entities from "../singleView/entities";
import {Participants, sortParticipants} from "../singleView/participants";
import {Grid} from "../../grid/grid";
import {CustomMap} from "../../carto/custom_map";
import {MarkdownElement} from "../../utils/text";
import {setFocusTheme,setNotifyTheme} from "../../api";
import {useTranslation} from "react-i18next";
import '../style/contact_profil.css'


function settings_is_focused(id, focus) {
  return (focus[id] || {}).focus_enabled;
}

function settings_is_notification(id, focus) {
  return (focus[id] || {}).notification_enabled;
}

function ThemeView({theme}){
  const { t } = useTranslation();
  const { route } = useRouteNode('explore.theme');
  let { data, name, params} = route;
  const {id, item, confidential, entities, contacts, grid} = theme;

  const [focus_checked, setFocusChecked] = useState(
    settings_is_focused(id, data.focus_theme || {})
  );
  const [notification_checked, setNotificationChecked] = useState(
    settings_is_notification(id, data.focus_theme || {})
  );

  name = 'explore.theme' === name ? `explore.theme.briefing` : name;

  const tabContent = [
    {"title": "Briefing", "root": "explore.theme.briefing"},
    {"title": t("Participants"), "root": "explore.theme.participants"},
    data.custom_map &&
    {"title": t("Cartographie"), "root": "explore.theme.custom_map"},
    // {"title": "Arborescense", "root": "explore.theme.arborescense"},
  ]
  .filter(x => x)
  .map(x => {
    return {...x, params, options: {replace: true}};
  });
  let view;

  let description = null;
  let subtitle = null;

  if (name.startsWith("explore.theme.briefing")) {
    description = data.grid?.description;
    description = description ? <MarkdownElement text={description}/> : description;

    if (data.grid?.owner) {
      subtitle = <div className="c-theme_view-owner">
	<div className="c-theme_view-owner_label">
	  { t("In charge:") }
	</div>
	<div className="c-theme_view-owner_name">
          { (data.grid.owner.firstname + " " + data.grid.owner.lastname) }
	</div>
      </div>
    }

    view = <div style={{display: "flex"}} className="embedded">
     <Briefing data={data} root={"theme"}/>
     {data.grid && <Grid name="explore.theme.briefing"/>}
    </div>
  } else if (name === "explore.theme.participants"){

    const {contact_nodes, entity_nodes} = grid || {contact_nodes: [], entity_nodes: []};

    const contacts_with_grid = contacts.map(x => {
      const grid_node = contact_nodes.find(node => node.poi_contact_id === x.id);
      return {...x, type: "contact", grid_node};
    })

    const entities_with_grid = entities.map(x => {
      const grid_node = entity_nodes.find(node => node.poi_entity_id === x.id);
      return {...x, type: "entity", grid_node};
    })

    const participants = sortParticipants(contacts_with_grid.concat(entities_with_grid));

    view = <div className="c-container_data">
      <Participants participants={participants} />
    </div>

  } else if (name === "explore.theme.reseaux"){
    const links_forward = contacts.map(c => {
      return {link_target_type: "poi_contact", poi_contact: c, type: null}
    })

    view = <div className="c-container_data">
      <Reseaux links_backward={[]} links_forward={links_forward}
               component_route="explore.contact" />
    </div>
  } else if (name === "explore.theme.entities"){
    const links_forward = entities.map(c => {
      return {link_target_type: "poi_entity", poi_entity: c, type: null}
    })

    view = <div className="c-container_data">
      <Entities links_backward={[]} links_forward={links_forward}
                component_route="explore.entity" />
    </div>
  } else if (name === "explore.theme.arborescense"){
    view = <Themes dataList={data} route={"theme"}/>;
  } else if (name.startsWith("explore.theme.custom_map")) {

    description = data.custom_map?.description;
    description = description ? <MarkdownElement text={description} /> : description;

    view = <div style={{display: "flex"}} className="embedded">
     <Briefing data={data} root={"theme"}/>
     {data.custom_map && <CustomMap />}
    </div>
  }

  function setThemeFocus({id}){
    setFocusChecked(!focus_checked);
    setFocusTheme(id, focus_checked ? "unset" : "set");
  }
  function setThemeNotification({id}){
    setNotificationChecked(!notification_checked);
    setNotifyTheme(id, notification_checked ? "unset" : "set");
  }

  return (
    <>
      <div className="c-profil_resume contact theme">
        <div className="c-resume_img" style={{justifyContent: "normal"}}>
	  <div className="c-infos_name">
	    <div>
	      {item}
	      { confidential &&
		<div className="lock-icon" style={{display: "inline-block",  marginLeft: "5px", marginBottom: "-1px"}} />
	      }
	    </div>
	    {subtitle}
	  </div>

	  {description &&
	   <div
	     className="c-theme_view-description"
	     style={{minHeight: "80px", flexGrow: 1, marginTop: "-10px" /* eat <p> in markdown */}}>
	     {description}
	    </div>
	  }
	  {!description && <div style={{flexGrow: 1}} />}

	  <div className="c-img_buttons">
	    <span className={`c-button_notification ${notification_checked ? 'active' : ''}`} onClick={() => setThemeNotification({id})}></span>
	    <span className={`c-button_focus ${focus_checked ? 'active' : ''}`} onClick={() => setThemeFocus({id})}></span>
	  </div>
        </div>
      </div>
      <div className="c-profil_authorFeed contact">
        <div className="c-container_menu">
          <Tab active={tabContent.map(x => x.root).indexOf(name)}>
            {tabContent.map((tab, idx) => (
                <Tab.TabPane key={`Tab-${idx}`} tab={tab.title} root={tab.root} params={tab.params} options={tab.options}/>
              ))
            }
          </Tab>
        </div>
            {view}
      </div>
    </>
  );
}

export default ThemeView
